import { Injectable } from '@angular/core';
import { HttpClient, HttpClientModule, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment.prod';
import { catchError, map } from 'rxjs/operators';



@Injectable({
  providedIn: 'root'
})
export class WpService {
  URL = environment.baseUrl;

  constructor(private http: HttpClient) { }
  
  /*
  // URL del blog que vamos a trabajar con su REST API
  public URL = 'http://demo.dospu.online/noticias/';
  public API = `${this.URL}wp-json/wp/v2/posts`;

  constructor(private http: HttpClient) { }

  /**
   * Numero de post que quieres mostrar
   * @param id
   */  
  /*
  getAll(id: number) {
    return this.http.get(`${this.API}?_embed&per_page=${id}`);
  }

  /**
   * Slug del post que vamos a mostrar
   * @param id
   */
  /*
  getSinglePost(id: string) {
    return this.http.get(`${this.API}?_embed&slug=${id}`);
  }*/
  getPosts(): Observable<any[]> {
    return this.http.get<any[]>('https://dospu1.unsl.edu.ar/noticias/wp-json/wp/v2/posts?_embed', {
      params: {
        per_page: '3'
      }
    }
    );  
  }
  
  getPostsDestacado(): Observable<any[]> {
    return this.http.get<any[]>(`https://dospu1.unsl.edu.ar/noticias/wp-json/wp/v2/posts?_embed&categories=6`, {      
      params: {
        per_page: '3',

      }
    }).pipe(
      map(posts => {
        // Si no hay elementos, devuelve un array con un objeto que contiene la URL de la imagen alternativa
        if (posts.length === 0) {
          return [{
            title: { rendered: 'Enterate de nuestras últimas novedades' },
          guid: { rendered: 'https://dospu1.unsl.edu.ar/noticias/' },  // Puedes poner aquí una URL o un placeholder
          _embedded: { 
            'wp:featuredmedia': [{
              source_url: 'https://dospu1.unsl.edu.ar/noticias/wp-content/uploads/2023/04/Iman.png'
              }]
            }
          }];
        }
        return posts;
      }),    
    catchError(error => {
      console.error('Error al obtener las publicaciones:', error);
      // Devuelve un array con un objeto que contiene la URL de la imagen alternativa en caso de error
      return of([{
        title: { rendered: 'Enterate de nuestras últimas novedades' },
        guid: { rendered: 'https://dospu1.unsl.edu.ar/noticias/' },  // Puedes poner aquí una URL o un placeholder
        _embedded: { 
          'wp:featuredmedia': [{
            source_url: 'https://dospu1.unsl.edu.ar/noticias/wp-content/uploads/2023/04/Iman.png'
          }]
        }
      }]);
    })
  );
}
  getPostsDeCom(): Observable<any[]> {
    return this.http.get<any[]>(`https://dospu1.unsl.edu.ar/noticias/wp-json/wp/v2/posts?_embed&categories=8`, {      
      params: {
        per_page: '3',

      }
    });
  }
  /**
   * Slug del post que vamos a mostrar
   * @param id
   */
  getSinglePost(id: string) {
    return this.http.get(`https://dospu1.unsl.edu.ar/noticias/wp-json/wp/v2/posts?_embed&slug=sdgfsdgsdfgds`);
    
  }

  insertarDatos(inscripto: any):Observable<any>{  
    let params = JSON.stringify(inscripto);
    let headers = new HttpHeaders({
      'Content-Type': 'application/json'
      });      
    return this.http.post(this.URL+`/insertar.php`, params, {headers: headers})
    
    
  }
  insertarDatosElecciones(inscripto: any):Observable<any>{  
    let params = JSON.stringify(inscripto);
    let headers = new HttpHeaders({
      'Content-Type': 'application/json'
      });      
    return this.http.post(this.URL+`/insertarElecciones.php`, params, {headers: headers})
    
    
  }/*
  insertarDatos( inscripto: any) {
    const newpres = JSON.stringify(inscripto);
    const headers = new HttpHeaders({
    'Content-Type': 'application/json'
    });
    return this.http.post( this.URL, newpres, {headers});
    
    

}*/
}
